import React, { Component } from "react";
import SessionStore from "../stores/SessionStore";
import ApplicationStore from "../stores/ApplicationStore";
import OrganizationStore from "../stores/OrganizationStore";

class CopyApplicationModal extends Component {
    constructor() {
      super();
      this.onChange = this.onChange.bind(this);
      this.state = {
        nowOrgName: "",
        nowOrgID: null,
        toOrgID: null,
        organizations: [],
        applications: [],
      };
    }
  
    componentDidMount() {
     
    }
  
    componentDidUpdate(prevProps) {
      if (this.props.app.id && this.props.app.id !== prevProps.app.id){
        OrganizationStore.getAllowCopyOrganizations(this.props.app.id, (totalCount, organizations)=>{
          this.setState({organizations: organizations})
          if (organizations.length > 0) {
            this.setState({toOrgID:organizations[0].id})

            //现在把默认组织和应用选上
            this.props.onCopyToChange(this.state.organizations[0].id,"org")
            this.props.onCopyToChange(0,"app")
            // ApplicationStore.getAllForOrganization(parseInt(this.state.organizations[0].id, 10), 999999, 0,"", (totalCount, applications) => {
            //   this.setState({applications: applications.filter(v => v.id !== this.props.app.id && (
            //     (SessionStore.isAdmin()
            //     || (SessionStore.isOrganizationAdmin(this.state.organizations[0].id)
            //     || SessionStore.isApplicationAdmin(v.id)))
            //   )) 
            //   })
            //   //如果是admin用户或者是目的组织的admin那就可以新建
            //   if (SessionStore.isAdmin() || SessionStore.isOrganizationAdmin(this.state.organizations[0].id)) {
            //     this.props.onCopyToChange(0,"app")
            //   }else if (this.state.applications.length > 0) {
            //     this.props.onCopyToChange(parseInt(this.state.applications[0].id, 10),"app")
            //   }
            // })
          }
        });
  
        ApplicationStore.getApplication(this.props.app.id,(app) =>{
          // organizationID
          this.setState({nowOrgID:app.organizationID})
          OrganizationStore.getOrganization(app.organizationID,(org)=>{
            this.setState({nowOrgName: org.name})
          })
        })
      }
    }
    
    onChange = (filed,e) => {
      if (filed === "app") {
        this.props.onCopyToChange(parseInt(e.target.value, 10),"app")
      }else if (filed === "org"){
        //组织改变了，选中的应用先清０
        this.props.onCopyToChange(e.target.value,"org")
        this.props.onCopyToChange(0,"app")
        this.setState({toOrgID: e.target.value})
        //拿到组织id去请求应用
        // ApplicationStore.getAllForOrganization(parseInt(e.target.value, 10), 999999, 0,"", (totalCount, applications) => {
        //   const apps = applications.filter(v => v.id !== this.props.app.id && (
        //     (SessionStore.isAdmin()
        //     || (SessionStore.isOrganizationAdmin(this.state.toOrgID)
        //     || SessionStore.isApplicationAdmin(v.id)))
        //   ))
  
        //   this.setState({applications:  apps})
        //   //如果是admin用户或者是目的组织的admin那就可以新建
        //   if (SessionStore.isAdmin() || SessionStore.isOrganizationAdmin(this.state.toOrgID)) {
        //     this.props.onCopyToChange(0,"app")
        //   }else if (this.state.applications.length > 0) {
        //     this.props.onCopyToChange(parseInt(this.state.applications[0].id, 10),"app")
        //   }
        // })
      }
    }
  
    render () {
      return (
        <div className="modal" tabindex="-1" style={{ display: this.props.showModal ? 'block' : 'none' }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Copy Application</h5>
              </div>
              <div className="modal-body">
                <label style={{fontSize: '16px'}}>Source organization</label>
                <p className='mySelect'>{this.state.nowOrgName}</p>
                <label style={{fontSize: '16px'}}>Source application</label>
                <p className='mySelect'>{this.props.app.name}</p>
                <label style={{fontSize: '16px'}}>Destination organization</label>
                <select className="form-control mySelect" id="orgName" name="orgName" onChange={this.onChange.bind(this,"org")}>
                {this.state.organizations.map(org => (
                  <option key={org.id} value={org.id}>{org.name}</option>
                ))}
                </select>
  
                {/* <label style={{fontSize: '16px'}}>Select which application you want to copy to</label> */}
                {/* <select className="form-control mySelect" id="appName" name="appName" onChange={this.onChange.bind(this,"app")}> */}
                  {/* admin或者是要去往组织的admin用户才能新建 */}
                {/* {(SessionStore.isAdmin() || SessionStore.isOrganizationAdmin(this.state.toOrgID))&& <option key={0} value={0}>New </option>} */}
                {/* {this.state.applications.map(app => ( */}
                  {/* <option key={app.id} value={app.id}>{app.name}</option> */}
                {/* ))} */}
                {/* </select> */}
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={this.props.closeModal}>Cencel</button>
                <button type="button" className="btn btn-primary" onClick={this.props.copyApplication}>OK</button>
              </div>
            </div>
          </div>
        </div>
      );
    }
  }

  export default CopyApplicationModal;


// WEBPACK FOOTER //
// ./src/components/CopyApplication.js